import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const tourInfoRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const tourIcon = css({
  width: '24px',
  height: '24px',
  flexShrink: 0,
});

export const tourTypeLabel = css({
  fontSize: 'md',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const tourDateTime = css({
  fontSize: 'sm',
  color: 'hpxBlue500',
});

export const ctaRow = css({
  display: 'flex',
  gap: '1x',
  marginTop: '1x',
});
